import {z} from 'zod';

export const loginSchema = z.object({
  email: z.string().email('Invalid email format'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
});

export const tutorSignUpSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  phone: z.string().min(10, 'Phone must be at least 10 characters'),
  email: z.string().email('Invalid email format'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  terms:     z
    .boolean()
    .refine(val => val === true, {
      message: 'You must accept the terms and conditions',
  }),
});

export const tutorBasicInfoSchema = z.object({
  school: z.string().min(1, 'School\'s name is required'),
  schoolId: z.string().min(1, 'Student\'s ID is required'),
  parentFirstName: z.string().min(1, "Parent's First Name is required"),
  parentLastName: z.string().min(1, "Parent's Last Name is required"),
  parentEmail: z.string().email('Parent\'s email format is invalid'),
  parentPhone:  z.string().min(10, 'Parent\'s phone must be at least 10 characters'),
  grade: z.string().min(1, 'Grade is required'),
  bio: z.string().min(10, 'Bio must be at least 10 characters').max(500, 'Bio must be less than 500 characters'),
  //languageSpoken: z.string().min(1, 'At least one language is required'),
  //subjectsTaught: z.string().min(1, 'At least one subject is required'),
});

export const parentDetailInfoSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  phone: z.string().min(1, 'Phone is required'),
  email: z.string().min(1, 'Email is required'),
});



export const tutorAcademicInfoSchema = z.object({
  degree: z.string().min(1, 'Degree is required'),
  university: z.string().min(1, 'University is required'),
  certificates: z.string().min(1, 'Certificates are required'),
  passingYear: z
    .string()
    .min(4, 'Valid passing year is required')
    .regex(/^\d{4}$/, 'Must be a 4-digit year'),
  issuedBy: z.string().min(1, 'Issuing authority is required'),
  weightedGPA: z.string().min(1, 'Weighted GPA is required'),
});

export const studentSignUpSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  phone: z.string().min(10, 'Phone number must be at least 10 digits'),
  grade: z.string().min(1, 'Grade is required'),
  school: z.string().min(1, 'School is required'),
});

// New schema for AddCourseBasicScreen
export const addCourseBasicSchema = z.object({
  className: z.string().min(1, 'Class Name is required'),
  acceptedCourseName: z.string().min(1, 'Accepted Course Name is required'),
  description: z.string().min(1, 'Description is required'),
  category: z.string().min(1, 'Category is required'),
  subCategory: z.string().min(1, 'Sub Category is required'),
  courseFees: z
    .string()
    .min(1, 'Course Fees is required')
    .regex(/^\d+(\.\d{1,2})?$/, 'Course Fees must be a valid number'),
});

export const addCourseContentSchema = z.object({
  courseContent: z.string().min(1, 'Course Content is required'),
  courseMaterial: z.string().min(1, 'Course Material is required'),
  courseCertificate: z.string().min(1, 'Course Certificate is required'),
  duration: z.string().min(1, 'Duration is required'),
  lessons: z.string().min(1, 'Lessons is required'),
  examCount: z.string().min(1, 'Exams is required'),
  startDate: z.date({required_error: 'Start Date is required'}),
  endDate: z.date({required_error: 'End Date is required'}),
  startTime: z.date({required_error: 'Start Time is required'}),
  endTime: z.date({required_error: 'End Time is required'}),
  maxStudents: z
    .string()
    .min(1, 'Maximum Students is required')
    .regex(/^\d+$/, 'Maximum Students must be a valid number'),
  courseLocation: z.string().min(1, 'Location is required'),
  address: z.string().optional(),
  suitableForGrade: z.string().min(1, 'Suitable for Grade is required'),
}).refine((data) => {
  // If location is selected, address is required
  if (data.courseLocation && !data.address) {
    return false;
  }
  return true;
}, {
  message: 'This field is required',
  path: ['address']
});


export const courseBasicInformationSchema = z.object({
  courseName:       z.string().min(1, 'Required'),
  courseDesc:       z.string().min(1, 'Required'),
  courseSubjects:   z.array(z.string()).min(1, 'Select at least one'),
  courseDuration:   z
    .string()
    .regex(/^\d+$/, 'Must be a number')
    .min(1, 'Required'),
  price:            z
    .number({ invalid_type_error: 'Must be a number' })
    .refine(n => n > 0, 'Must be greater than zero'),
  weightedGPA:      z
    .number({ invalid_type_error: 'Must be a number' })
    .refine(n => n > 0, 'Must be greater than zero'),
  startDate:        z.date({ required_error: 'Required' }),
  endDate:          z.date({ required_error: 'Required' }),
  location:         z.string().min(1, 'Location is required'),
  address:          z.string().optional()
}).refine((data) => {
  // If location is selected, address is required
  if (data.location && !data.address) {
    return false;
  }
  return true;
}, {
  message: 'This field is required',
  path: ['address']
});